export default "__VITE_ASSET__CUxCZFw9__"